//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsIcon} from '@nuskin/ns-icon';
export default {
  name: 'Usage',
  components: {
    NsIcon
  },
  props: {
    video: {
      type: Object,
      default: () => ({})
    },
    steps: {
      type: Array,
      default: () => []
    },
    recommendations: {
      type: Array,
      default: () => []
    },
    warnings: {
      type: Array,
      default: () => []
    },
    additionalText: {
      type: Array,
      default: () => []
    },
    image: {
      type: Object,
      default: () => ({
        url: '',
        alt: ''
      })
    },
    youTubeVideoId: {
      type: String,
      default: ''
    },
    isBundle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showVideo: false
    };
  },
  computed: {
    mobileAndPhablet() {
      return this.$mq === 'mobile' || this.$mq === 'phablet';
    }
  },
  watch: {
    showVideo(show) {
      if (show) {
        this.$refs.video.play();
        this.$refs.video.addEventListener('ended', this.closeVideo);
      }
    }
  },
  destroyed() {
    if (this.showVideo && this.$refs.video) {
      this.$refs.video.removeEventListener('ended', this.closeVideo);
    }
  },
  methods: {
    closeVideo() {
      this.$refs.video.removeEventListener('ended', this.closeVideo);
      this.showVideo = false;
    }
  }
};
